import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LayoutNew.css";
import { useAuth } from "./AuthContext";
import MainLayout from "./components/layout/MainLayout";
import Login from "./components/auth/Login";

import Users from "./components/pages/users/Users";
import Dashboard from "./components/widgets/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import Networks from "./components/pages/networks/Networks";
import Cryptocurrencies from "./components/pages/cryptocurrencies/Cryptocurrencies";
import Swap from "./components/pages/swap/Swap";
import RewardSettings from "./components/pages/reward-settings/RewardSettings";
import RewardTransaction from "./components/pages/reward-transaction/RewardTransaction";
import StakingPlans from "./components/pages/staking-plans/StakingPlans";
import UserStaking from "./components/pages/user-staking/UserStaking";
import UserEtokenBalances from "./components/pages/user-etoken-balances/UserEtokenBalances";
import UserWatchPoints from "./components/pages/user-watch-points/UserWatchPoints";
import UserDailyBonus from "./components/pages/user-daily-bonus/UserDailyBonus";
import AdsSettings from "./components/pages/ads-settings/AdsSettings";
import AdsPointsSetting from "./components/pages/ads-points-setting/AdsPointsSetting";
function App() {
  const { login } = useAuth();

  useEffect(() => {
    const jwtToken = localStorage.getItem("jwtToken");
    if (jwtToken) {
      login();
    }
  }, [login]);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute component={<MainLayout><Dashboard /></MainLayout>} />}
          />

          <Route
            path="/users"
            element={<ProtectedRoute component={<MainLayout><Users /></MainLayout>} />}
          />
          <Route
            path="/networks"
            element={<ProtectedRoute component={<MainLayout><Networks /></MainLayout>} />}
          />
          <Route
            path="/cryptocurrencies"
            element={<ProtectedRoute component={<MainLayout><Cryptocurrencies /></MainLayout>} />}
          />
          <Route
            path="/swap"
            element={<ProtectedRoute component={<MainLayout><Swap /></MainLayout>} />}
          />

          <Route
            path="/reward-settings"
            element={<ProtectedRoute component={<MainLayout><RewardSettings /></MainLayout>} />}
          />
          <Route
            path="/reward-transactions"
            element={<ProtectedRoute component={<MainLayout><RewardTransaction /></MainLayout>} />}
          />
          <Route
            path="/staking-plans"
            element={<ProtectedRoute component={<MainLayout><StakingPlans /></MainLayout>} />}
          />
          <Route
            path="/user-staking"
            element={<ProtectedRoute component={<MainLayout><UserStaking /></MainLayout>} />}
          />
          <Route
            path="/user-staking/:id"
            element={<ProtectedRoute component={<MainLayout><UserStaking /></MainLayout>} />}
          />
          <Route
            path="/user-etoken-balances"
            element={<ProtectedRoute component={<MainLayout><UserEtokenBalances /></MainLayout>} />}
          />
          <Route
            path="/user-watch-points"
            element={<ProtectedRoute component={<MainLayout><UserWatchPoints /></MainLayout>} />}
          />
          <Route
            path="/user-watch-points/:id"
            element={<ProtectedRoute component={<MainLayout><UserWatchPoints /></MainLayout>} />}
          />
          <Route
            path="/user-daily-bonus"
            element={<ProtectedRoute component={<MainLayout><UserDailyBonus /></MainLayout>} />}
          />
          <Route
            path="/user-daily-bonus/:id"
            element={<ProtectedRoute component={<MainLayout><UserDailyBonus /></MainLayout>} />}
          />
          <Route
            path="/admob-settings"
            element={<ProtectedRoute component={<MainLayout><AdsSettings /></MainLayout>} />}
          />
          <Route
            path="/admob-points-settings"
            element={<ProtectedRoute component={<MainLayout><AdsPointsSetting /></MainLayout>} />}
          />


        </Routes>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
